/* eslint-disable */
/* @ts-nocheck */


import { Out } from "@/infrastructure/frontent/clientMessage";
import { geoConvertLib } from "../geo-modules/geo-point-calculations";
import { geoUtilities } from "../geo-modules/geo-poligon-utilities";
import { GeoCoordinates, geoMarker, GpsState } from "../geo-modules/geo-types";
import { GeoStateListening, GeoStateListeningAction, GeoViewListener } from "../hooks/GeoMapListener";
import { GpsListener, GpsListenerState } from "../hooks/GpsListener";
import { GeoStateAction, GeoView } from "../hooks/ChangeGeoMap";
import { Gps } from "../geo-modules/geo-gps-point";

let geoRequestState: any = undefined;
let geoMapState: any = undefined;
let mapDivId: any = undefined;

let gpsPosition: GeoCoordinates | undefined = undefined
let centerPosition: GeoCoordinates | undefined = undefined


let markers: geoMarker[] = []


export const SetLeaflet = (l: any, mapDivIdParam: any | undefined, geoRequestStateParam: any, geoMapStateParam: any, gpsPositionParam: GeoCoordinates | undefined, centerPositionParam: GeoCoordinates | undefined, markersParam: geoMarker[]) => {
    //console.table(mapDivIdParam)


    geoRequestState = geoRequestStateParam;
    geoMapState = geoMapStateParam;
    mapDivId = mapDivIdParam;
    gpsPosition = gpsPositionParam;
    centerPosition = centerPositionParam;
    markers = markersParam;
}



export const geoMap = (function (geoConvertLib, utilities) {
    let tileLayerBase: any = undefined
    let markerMap = new Map();
    let map: any = undefined

    const geoViewActionService = GeoView.getService()
    const geoListenerService = GeoViewListener.getService()

    function getMap() {
        if (!map) {
            return undefined
        }
        return map
    }

    async function initMap() {
        //await load()

        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (map) {
                const container = map.getContainer();
                if ( container.id === mapDivId) {
                    cleanUp()
                   map = undefined
                }
            }

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            map = new L.Map(mapDivId,
                {
                    maxNativeZoom: 29,
                    minZoom: 8,
                    zoomSnap: 0.25,
                    maxZoom: 24,
                    continuousWorld: true,
                    worldCopyJump: false,
                });
        } catch (e) {
            console.error(`Fehler: initMap: ${e}`)
            Out.noOperation("")
        }

        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            tileLayerBase = new L.tileLayer.wms("https://wms.geo.admin.ch/?", {
                layers: 'ch.swisstopo.pixelkarte-farbe',
                format: 'image/jpeg',
                detectRetina: true,
                maxNativeZoom: 29, minZoom: 8, maxZoom: 24
            });
        } catch (e) {
            Out.noOperation("")
        }

        try {
            map.addLayer(tileLayerBase);
        } catch (e) {
            Out.noOperation("")
        }

        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            L.control.scale().addTo(map);
        } catch (e) {
            Out.noOperation("")
        }


        try {
            if (geoRequestState.gpsMode === "Allowed" || geoRequestState.gpsMode === "OnStartup") {
                setGpsControlTool()
            }
        } catch (e) {
            Out.noOperation("")
        }

        try {
            if (geoRequestState.editMode === "New" || geoRequestState.editMode === "Change") {
                activateControlTool()
            }
        } catch (e) {
            Out.noOperation("")
        }


        try {
            if (geoRequestState.centerVisible)
                activateCenterTool()
        } catch (e) {
            Out.noOperation("")
        }

        try {
            map.on('moveend', function (e: any) {
                onBoundsChange(map.getBounds());
            });
        } catch (e) {
            Out.noOperation("")
        }


    }

function SetCenterPosition(centerPositionParam: GeoCoordinates | undefined) {
    centerPosition = centerPositionParam;
}

    function onBoundsChange(bounds: any) {
        if (bounds) {
            const store = geoViewActionService.getGeoMapStateStore()
            store.longitudeSouthWest = bounds._southWest.lng
            store.latitudeSouthWest = bounds._southWest.lat
            store.longitudeNorthEast = bounds._northEast.lng
            store.latitudeNorthEast = bounds._northEast.lat
            geoViewActionService.changeGeoMapStateStore(store)
        }
    }



    function setGpsControlTool() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        L.Control.Button = L.Control.extend({
            options: {
                position: 'topleft'
            },
            onAdd: function (map: any) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var button = L.DomUtil.create('a', 'leaflet-control-button', container);
                button.innerHTML = '<img class="leafletIcon" src="img/icons/gps-position.svg">';
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                L.DomEvent.disableClickPropagation(button);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                L.DomEvent.on(button, 'click', function () {
                    if (!geoMapState.isEditable) return
                    panToGps()
                });
                container.title = geoMapState.GpsHint;

                return container;
            },
            onRemove: function (map: any) {
                Out.noOperation("")
            },
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var control = new L.Control.Button()
        control.addTo(map);
    }

    function activateControlTool() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        L.Control.Button = L.Control.extend({
            name: "activate",
            options: {
                position: 'topleft'
            },
            onAdd: function (map: any) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var button = L.DomUtil.create('a', 'leaflet-control-button', container);
                button.innerHTML = '<img class="leafletIcon" src="img/icons/gps-position-edit.svg">';
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                L.DomEvent.disableClickPropagation(button);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                L.DomEvent.on(button, 'click', function () {
                    if (!geoMapState.isEditable) return
                    toggleEditMode()
                });
                container.title = geoMapState.Activated;

                return container;
            },
            onRemove: function (map: any) {
                Out.noOperation("")
            },
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var control = new L.Control.Button()
        control.addTo(map);
    }

    function activateCenterTool() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        L.Control.Button = L.Control.extend({
            options: {
                position: 'topleft'
            },
            onAdd: function (map: any) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var button = L.DomUtil.create('a', 'leaflet-control-button', container);
                button.innerHTML = '<img class="leafletIcon" src="img/icons/geo-center.svg">';
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                L.DomEvent.disableClickPropagation(button);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                L.DomEvent.on(button, 'click', function () {
                    if (!geoMapState.isEditable) return
                    center()
                });
                container.title = geoMapState.Center;

                return container;
            },
            onRemove: function (map: any) {
                Out.noOperation("")
            },
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var control = new L.Control.Button()
        control.addTo(map);
    }

    function disableControlBar(enabled: boolean) {
        try {
            let style = "allowed"
            if (!enabled) style = "not-allowed"
            Out.noOperation("")
            var mapContainer = map.getContainer();
            var controlContainer = mapContainer.getElementsByClassName("leaflet-control")[1];
            controlContainer.style.cursor = style
            controlContainer = mapContainer.getElementsByClassName("leaflet-control")[2];
            controlContainer.style.cursor = style
            controlContainer = mapContainer.getElementsByClassName("leaflet-control")[3];
            controlContainer.style.cursor = style
        } catch (e) {
            Out.noOperation()
        }

    }

    function SetEditMarker(color: any, size: any) {
        const svgTemplate = `
    <svg xmlns="http://www.w3.org/2000/svg" class="marker">
      <circle cx="24" cy="24" r="12" stroke="red"stroke-width="5" fill="#${color}" />
    </svg>`;
        if (size === "Big") {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return L.divIcon({ className: 'marker', html: svgTemplate, iconSize: [40, 40], iconAnchor: [20, 20], popupAnchor: [7, -16], });
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return L.divIcon({ className: 'marker', html: svgTemplate, iconSize: [20, 20], iconAnchor: [10, 10], popupAnchor: [7, -16], });
    }

    function SetSelectedMarker(color: any, size: any) {
        const svgTemplate = `
    <svg xmlns="http://www.w3.org/2000/svg" class="marker">
      <circle cx="24" cy="24" r="8" stroke="gray" stroke-width="6" fill="#${color}" />
    </svg>`;
        if (size === "Big") {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return L.divIcon({ className: 'marker', html: svgTemplate, iconSize: [40, 40], iconAnchor: [20, 20], popupAnchor: [7, -16], });
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return L.divIcon({ className: 'marker', html: svgTemplate, iconSize: [20, 20], iconAnchor: [10, 10], popupAnchor: [7, -16], });
    }




    // function showRevier(data: any) {

    //     try {
    //         map.eachLayer(function (layer: any) {
    //             if (layer.toGeoJSON) {
    //                 map.removeLayer(layer);
    //             }
    //         });
    //     } catch (e) {
    //         Out.noOperation()
    //     }

    //     if (data.features == null) {
    //         return;
    //     }



    //     try {
    //         let isMultiPolygon = data.features[0].geometry.type === 'MultiPolygon';
    //         let minMaxBounds = utilities.getBoundingBox(data, isMultiPolygon);
    //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //         // @ts-ignore
    //         let southWest = L.latLng(minMaxBounds.southWestLat, minMaxBounds.southWestLong),
    //             // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //             // @ts-ignore
    //             northEast = L.latLng(minMaxBounds.northEastLat, minMaxBounds.northEastLong),
    //             // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //             // @ts-ignore
    //             bounds = L.latLngBounds(southWest, northEast);

    //         map.fitBounds(bounds);
    //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //         // @ts-ignore
    //         L.geoJson(data).addTo(map);
    //     } catch (e) {
    //         Out.noOperation()
    //     }

    // }

    function newMarker(lng: number, lat: number, id: any, isDraggable: boolean, info: string, data: geoMarker[], callback: any) {
        try {

            if (!map) return

            //releaseSelectedMarker();
            const newData: geoMarker = {
                "Id": id,
                "Typ": "",
                "RevierId": "",
                "RevierNummer": 0,
                "RevierName": "",
                "Symbol": "",
                "Farbe": "",
                "Size": "Big",
                "X_Koordinate": lng,
                "Y_Koordinate": lat,
                "InfoText": info
            };

            if (data == null) {
                data = [];
            }

            data.push(newData);

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            let marker = new L.marker([lat, lng], { icon: SetSelectedMarker("2E64FE", "Big"), draggable: isDraggable, id: id })
            if (isDraggable) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore               
                marker = new L.marker([lat, lng], { icon: SetEditMarker("FF781F", "Big"), draggable: isDraggable, id: id })
            }


            marker.on("dragend", function (e: any) {
                try {
                    let coordinates = e.target.getLatLng();
                    const lv03 = geoConvertLib.WGStoCH(coordinates.lat, coordinates.lng);
                    const lv095 = geoConvertLib.Lv03ToLv095(lv03);
                    const point = {
                        lat: lv095[0],
                        lng: lv095[1]
                    }
                    callback(newData, point, coordinates, id, "dragend");
                }
                catch (e) {
                    console.error(`Fehler: dragend callback: ${e}`)
                }
            });

            marker.addTo(map);
            markerMap.set(id, marker);


            try {
                const lv03 = geoConvertLib.WGStoCH(lat, lng);
                const lv095 = geoConvertLib.Lv03ToLv095(lv03);
                const point = {
                    lat: lv095[0],
                    lng: lv095[1]
                }
                callback(newData, point, { lat: lat, lng: lng }, id, "create");
            }
            catch (e) {
                console.error(`Fehler: create callback: ${e}`)
            }

        }
        catch (e) {
            console.error(`Fehler: newMarker: ${e}`)
        }
    }

    function removeMarker(id: any) {
        try {
            if (!markerMap && !map) return
            const marker = markerMap.get(id);
            if (!marker) return
            map.removeLayer(marker);
            markerMap.delete(id)
        } catch (e) {
            Out.noOperation("")
        }
    }


    function fitBounds(longitudeNorthEast: number, latitudeNorthEast: number, longitudeSouthWest: number, latitudeSouthWest: number): void {

        if (!map) return

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore        
        let southWest = L.latLng(latitudeSouthWest, longitudeSouthWest),
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            northEast = L.latLng(latitudeNorthEast, longitudeNorthEast),
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            bounds = L.latLngBounds(southWest, northEast);

        map.fitBounds(bounds);



    }

    function cleanUp() {
        try {
            if (!map) return
            map.off();
            map.remove();

            // const mapDiv = document.getElementById(mapDivId);
            //     if (mapDiv) {
            //         while (mapDiv.firstChild) {
            //             mapDiv.removeChild(mapDiv.firstChild);
            //         }
            //     }

            // const parent = document.getElementById('mapParent');
            // const oldDiv = document.getElementById(mapDivId);
            // if (oldDiv && parent) {
            //     parent.removeChild(oldDiv);
            // } else {
            //     return
            // }

            // // Create and add the new div with the same id and class
            // if (parent) {
            //     const newDiv = document.createElement('div');
            //     newDiv.id = mapDivId;
            //     //newDiv.className = getGeoClass();
            //     parent.appendChild(newDiv);
            // }
            //console.log("GeoMap cleaned up:" + mapDivId)
        } catch (e) {
            console.error(`Fehler: cleanUp: ${e}`)
            Out.noOperation("")
        }
    }

    function pan(lng: number | undefined, lat: number | undefined): void {
        if (map) {
            map.setView([lat, lng]);
        }
    }

    function setView(lng: number | undefined, lat: number | undefined): boolean {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore        
        if (map) {
            map.setView([lat, lng], 12);
            return true;
        } else {
            return false
        }
    }

    function toggleEditMode() {
        if (geoMapState.editActivated) {
            //sendCurrentGeoState()
            disableEditMode()
            return
        }
        enableEditMode();
    }

    function panToGps() {
        geoMapState.panToGps = true
        Gps.CalculateGps("Save")

    }

    function center() {
        if (centerPosition && centerPosition.longitude && centerPosition.latitude && centerPosition.longitude > 0 && centerPosition.latitude > 0 && geoMapState.RevierNumber) {
            pan(centerPosition.longitude, centerPosition.latitude)
            setTimeout(() => {
                if (centerPosition) {
                    removeMarker(1)
                    newMarker(centerPosition.longitude, centerPosition.latitude, 1, geoMapState.editActivated, "", markers, markerHandler)
                    const store = geoViewActionService.getGeoMapStateStore()
                    store.longitude = centerPosition.longitude
                    store.latitude = centerPosition.latitude
                    geoViewActionService.changeGeoMapStateStore(store)
                    sendCurrentGeoState()
                }
            }, 0)
        } else {

            const point = getGeoKoordinate(geoMapState.ZentrumKoordinate)

            pan(point.longitude, point.latitude)
            setTimeout(() => {
                removeMarker(1)
                newMarker(point.longitude, point.latitude, 1, geoMapState.editActivated, "", markers, markerHandler)
                const store = geoViewActionService.getGeoMapStateStore()
                store.longitude = point.longitude
                store.latitude = point.latitude
                geoViewActionService.changeGeoMapStateStore(store)


            }, 0)

            // geoMap.pan(8.55,  47.36667)
            // setTimeout(()=>{            
            //     geoMap.removeMarker(1)
            //     geoMap.newMarker(8.55,  47.36667, 1, geoMapState.editActivated, "" , markers , markerHandler )
            //     const store = geoViewActionService.getGeoMapStateStore()
            //     store.longitude = 8.55
            //     store.latitude = 47.36667
            //     geoViewActionService.changeGeoMapStateStore(store)


            // },0)
        }
    }

    function getGeoKoordinate(longLat: string) {
        if (!longLat) return { longitude: 8.2319736, latitude: 46.7985624 }
        const temp = longLat.split(",")
        if (temp.length != 2) return { longitude: 8.2319736, latitude: 46.7985624 }

        try {
            return { longitude: parseFloat(temp[0]), latitude: parseFloat(temp[1]) }
        } catch (e) {
            return { longitude: 8.2319736, latitude: 46.7985624 }
        }
    }

    function enableEditMode() {
        setTimeout(() => {
            if (gpsPosition) {
                removeMarker(1)
                newMarker(gpsPosition.longitude, gpsPosition.latitude, 1, true, "", markers, markerHandler)
                geoMapState.editActivated = true
                const store = geoViewActionService.getGeoMapStateStore()
                store.editActice = true
                geoViewActionService.changeGeoMapStateStore(store)
            }
        }, 0)
    }

    function disableEditMode() {
        setTimeout(() => {
            if (gpsPosition) {
                removeMarker(1)
                newMarker(gpsPosition.longitude, gpsPosition.latitude, 1, false, "", markers, markerHandler)
                geoMapState.editActivated = false
                const store = geoViewActionService.getGeoMapStateStore()
                store.editActice = false
                geoViewActionService.changeGeoMapStateStore(store)

            }
        }, 0)
    }


    // ************************************* Marker Handler *************************************************


    function sendCurrentGeoState() {

        const store = geoViewActionService.getGeoMapStateStore()
        const geoState: GeoStateListening = {
            action: GeoStateListeningAction.OnDragEnded,
            wgs84X: store.latitude,
            wgs84Y: store.longitude,
            lv95X: undefined,
            lv95Y: undefined,
            isInsidePoligon: geoMapState.insidePolygon,
            revierNumber: geoMapState.RevierNumber,
            revierTyp: geoMapState.RevierTyp,
            editActivated: geoMapState.editActivated
        }

        if (!geoState.wgs84X || geoState.wgs84X < 1 || !geoState.wgs84Y || geoState.wgs84Y < 1)
            return

        const point = getLv095FromGps(geoState.wgs84Y, geoState.wgs84X)

        geoState.lv95Y = point.lng
        geoState.lv95X = point.lat

        geoListenerService.geoChanged(geoState)
    }

    function getLv095FromGps(x: number, y: number) {

        const latLng = geoConvertLib.WgsToLv95(y, x);

        return latLng
    }

    function markerHandler(data: any, coordinates: any, gpsCoordinates: any, markerIndex: any, messageType: any) {
        if (gpsCoordinates) {
            gpsPosition = { latitude: gpsCoordinates.lat, longitude: gpsCoordinates.lng }
        }
        if (coordinates) {


            let insideInPolygon = false
            try {
                insideInPolygon = geoUtilities.pointInPolygon(coordinates.lng, coordinates.lat, geoMapState.geoRevierData)
            } catch (e) {
                Out.noOperation("")
            }

            const geoState: GeoStateListening = {
                action: GeoStateListeningAction.OnDragEnded,
                wgs84X: gpsCoordinates.lat,
                wgs84Y: gpsCoordinates.lng,
                lv95X: coordinates.lat,
                lv95Y: coordinates.lng,
                isInsidePoligon: insideInPolygon,
                revierNumber: geoMapState.RevierNumber,
                revierTyp: geoMapState.RevierTyp,
                editActivated: geoMapState.editActivated
            }

            geoMapState.X = coordinates.lng.toString()
            geoMapState.Y = coordinates.lat.toString()

            const store = geoViewActionService.getGeoMapStateStore()
            store.longitude = gpsCoordinates.lng
            store.latitude = gpsCoordinates.lat
            geoViewActionService.changeGeoMapStateStore(store)


            if (!geoMapState.RevierNumber || geoMapState.RevierNumber.length < 1) {
                geoMapState.insidePolygon = false
            } else {
                geoMapState.insidePolygon = insideInPolygon
            }
            sendCurrentGeoState()
            Out.noOperation()
        }
    }

    // ***************************************** Gps Listener Service *******************************************
    const gpsListenerService = GpsListener.getService()
    const gpsListener = gpsListenerService.subscription().subscribe({
        next: (value) => {
            if (!value.gpsPosition) return
            if (geoRequestState.gpsMode === "Allowed" || geoRequestState.gpsMode === "OnStartup") {
                const gpsSignal = Gps.GetCurrentGpsSignal()
                setGpsPosition(gpsSignal, value.action)
                gpsListenerService.reset()
                if (value.action && value.action === "Save") {
                    try {
                        const store = geoViewActionService.getGeoMapStateStore()
                        store.longitude = gpsPosition?.longitude
                        store.latitude = gpsPosition?.latitude
                        geoViewActionService.changeGeoMapStateStore(store)
                        sendCurrentGeoState()
                    } catch (e) {
                        Out.noOperation("")
                    }
                }
            }
        }
    })


    function setGpsPosition(signal: GpsListenerState | undefined, action: string | undefined) {
        if (!signal || !signal.gpsState || signal.gpsState !== GpsState.PositionDelivered || !signal.gpsPosition) {
            if (centerPosition) {
                setMarker(centerPosition.longitude, centerPosition.latitude, geoMapState.editActivated)
                changeInsideOutsidePosition(centerPosition.longitude, centerPosition.latitude)
                if (geoMapState.panToGps) {
                    geoMapState.panToGps = false
                    pan(centerPosition.longitude, centerPosition.latitude)

                }
                gpsPosition = centerPosition
            }
            geoMapState.panToGps = false
            return
        }
        if (!signal || !signal.gpsPosition || !signal.gpsPosition.longitude || !signal.gpsPosition.latitude) {
            geoMapState.panToGps = false
            return
        }

        gpsPosition = { longitude: signal.gpsPosition.longitude, latitude: signal.gpsPosition.latitude }
        if (!gpsPosition) {
            geoMapState.panToGps = false
            return
        }



        if (gpsPosition && geoMapState.geoStateAction === GeoStateAction.ChangeRevierAndType || GeoStateAction.ChangeData) {
            setMarker(gpsPosition.longitude, gpsPosition.latitude, geoMapState.editActivated)
            changeInsideOutsidePosition(gpsPosition.longitude, gpsPosition.latitude)
            if (geoMapState.panToGps) {
                geoMapState.panToGps = false
                pan(gpsPosition?.longitude, gpsPosition?.latitude)
            }

        }



        if (geoMapState.geoStateAction === GeoStateAction.SetPositionOnly) {


            setView(gpsPosition?.longitude, gpsPosition?.latitude)
            setMarker(gpsPosition.longitude, gpsPosition.latitude, geoMapState.editActivated)
            let i = 0;
            const interval = setInterval(() => {
                if (i == 50 || setView(gpsPosition?.longitude, gpsPosition?.latitude)) {
                    clearInterval(interval)
                    setMarker(gpsPosition?.longitude, gpsPosition?.latitude, geoMapState.editActivated)
                    if (geoMapState.panToGps) {
                        geoMapState.panToGps = false
                        pan(gpsPosition?.longitude, gpsPosition?.latitude)
                    }

                }
                i++
            }, 400)

        }
    }

    function changeInsideOutsidePosition(longitude: number | undefined, latitude: number | undefined) {
        try {
            let insideInPolygon = false
            if (longitude && latitude) {
                try {
                    insideInPolygon = geoUtilities.pointInPolygon(longitude, latitude, geoMapState.geoRevierData)
                } catch (e) {
                    Out.noOperation("")
                }
            }
            geoMapState.insidePolygon = insideInPolygon
        } catch (e) {
            Out.noOperation("")
        }
    }



    function setMarker(longitude: number | undefined, latitude: number | undefined, draggable: boolean) {
        if (!longitude || !latitude) return
        setTimeout(() => {
            if (gpsPosition && gpsPosition.longitude > 0) {
                geoMap.removeMarker(1)
                geoMap.newMarker(gpsPosition.longitude, gpsPosition.latitude, 1, draggable, "", markers, markerHandler)
                const store = geoViewActionService.getGeoMapStateStore()
                store.longitude = gpsPosition.longitude
                store.latitude = gpsPosition.latitude
                geoViewActionService.changeGeoMapStateStore(store)
            }
        }, 0)
    }






    return {
        initMap,
        getMap,
        SetLeaflet,
        //showRevier,
        newMarker,
        setView,
        removeMarker,
        cleanUp,
        pan,
        fitBounds,
        disableControlBar,
        setMarker,
        toggleEditMode,
        panToGps,
        changeInsideOutsidePosition,
        sendCurrentGeoState,
        markerHandler,
        enableEditMode,
        disableEditMode,
        SetCenterPosition,
    }

})(geoConvertLib, geoUtilities);
